import styled from 'styled-components';
import React from 'react';
import { Spinner } from '../loader/EllipticalLoader';

const StyledIconInput = ({
  width,
  icon,
  placeholder = 'Search',
  inputClass,
  value,
  icon1,
  loading,
  onChange,
  className,
  elementRef,
  ...props
}) => {
  return (
    <div className={`rounded-pill ${className ? className : 'flex-grow-1'}`}>
      <InputStyled {...props}>
        {icon && icon}
        <input
          type="search"
          placeholder={placeholder}
          className={`${inputClass} ${props.small ? 'p-1' : 'p-2'} rounded-pill`}
          value={value}
          onChange={onChange}
          ref={elementRef}
        />
        {/* <span
          className={`spinner-border spinner-border-sm me-2 p-1 ${
            !loading ? 'd-none' : 'd-inline'
          }`}
          style={{
            transition: 'all 0.3s linear',
          }}
        /> */}
        <Spinner
          height="20px"
          width="20px"
          className={!loading ? 'd-none' : 'd-inline me-2'}
        />
        {icon1}
      </InputStyled>
    </div>
  );
};

const InputStyled = styled.div`
  padding: 0 0 0 6px;
  max-width: ${({ $maxWidth }) => ($maxWidth ? $maxWidth : '50em')};
  font-size: 12px;
  width: 100%;
  border-radius: ${({ theme }) => theme?.radiusPill || '16px'};
  border: ${({ theme }) =>
    theme?.dark
      ? `1.5px solid ${theme.borderSubtle || theme.inputBorder}`
      : `1.5px solid ${theme.inputBorder}`};
  display: flex;
  align-items: center;
  color: ${({ theme }) =>
    theme?.dark ? theme.textPrimary || '#F5F5F5' : theme.inputColor} !important;
  background-color: ${({ theme, $background }) =>
    $background || (theme.dark ? theme.fieldLabelBg : theme.bodyBg)};
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
  &:focus-within {
    color: ${({ theme }) =>
      theme?.dark ? theme.textPrimary || '#F5F5F5' : theme.inputColor};
    border: ${({ theme }) =>
      theme?.dark
        ? `1.5px solid ${theme.secondary}`
        : `1.5px solid ${theme.primary}`};
    box-shadow: 0 0 0 3px ${({ theme }) => theme?.dark ? 'rgba(220, 96, 30, 0.2)' : 'rgba(13, 35, 73, 0.12)'};
    background-color: ${({ theme, $background }) =>
      $background || (theme.dark ? theme.fieldLabelBg : theme.bodyBg)};
  }
  input {
    border: 0;
    border-radius: ${({ $borderRadius }) =>
      $borderRadius ? $borderRadius : '0'};
    width: 100%;
    margin-left: ${({ $marginLeft }) => ($marginLeft ? $marginLeft : '3px')};
    font-weight: 600;
    background-color: ${({ theme, $background }) =>
      $background || (theme.dark ? theme.fieldLabelBg : theme.bodyBg)};
    &:valid {
      background-image: none;
    }
    &:focus {
      box-shadow: none;
      outline: none;
      border: 0;
      background-color: ${({ theme, $background }) =>
        $background || (theme.dark ? theme.fieldLabelBg : theme.bodyBg)};
    }
    &::placeholder {
      color: ${({ theme }) => theme.inputPlaceHolder};
      opacity: 1;
    }
  }
`;

export default StyledIconInput;
